import {getIntlLanguage} from '@di-shared/features/common/useInferableTranslation';

export function formatLocaleNumberWithCommas(input: number | string | null | undefined, lang: string) {
  const numberInput = Number(input);
  return numberInput.toLocaleString(lang);
}

export function formatNumberWithCommas(input: number | string | null | undefined) {
  return formatLocaleNumberWithCommas(input, getIntlLanguage());
}

export function roundToFixed(value: number, digit: number) {
  return String(Number(Math.round(Number(value + 'e' + digit)) + 'e-' + digit));
}
